import {Link, Text} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {useInRouterContext, Link as ReactLink} from 'react-router-dom';

import {suffixTestId, TestIdProps} from 'shared/web';

export interface BreadcrumbLinkProps extends TestIdProps {
  href?: string;
  children: string;
  isCurrentPage?: boolean;
}

export function BreadcrumbLink(props: BreadcrumbLinkProps) {
  const isInsideReactRouter = useInRouterContext();

  return match([Boolean(props.isCurrentPage), isInsideReactRouter])
    .with([true, Pattern.any], () => (
      <Text size="xSmall" data-testid={suffixTestId('breadcrumbLink', props)}>
        {props.children}
      </Text>
    ))
    .with([false, true], () => (
      <ReactLink to={props.href ?? '/'} data-testid={suffixTestId('breadcrumbLink', props)}>
        <Text size="xSmall" color="link">
          {props.children}
        </Text>
      </ReactLink>
    ))
    .otherwise(() => (
      <Link
        size="xSmall"
        href={props.href ?? '/'}
        data-testid={suffixTestId('breadcrumbLink', props)}
        title={props.children}
      />
    ));
}
